
import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import AbpBase from '@/lib/abpbase'
import header1 from '@/components/headers/header.vue';
import footer1 from '@/components/footers/footer.vue';
import QrCode from 'qrcodejs2';
import VipCardOrder from '@/store/entities/ordering/VipCardOrder';
import VipCard from '@/store/entities/finance/VipCard';
import util from '@/lib/util';
import appConsts from "@/lib/appConst";

@Component({
  components: { header1, footer1 }
})
export default class VipRegister extends AbpBase {
  currentItem: number = 0;
  currentVipCard: VipCard = new VipCard();
  placeholderQrcodeVisible: boolean = true;

  get tenant() {
    return util.abp.multiTenancy.getTenantCookie();
  }

  get userProfile() {
    return this.$store.state.session.userProfile;
  }

  get list() {
    return this.$store.state.vipCard.list;
  }

  get wallet() {
    return this.$store.state.wallet.editWallet;
  }

  created() {
    this.$store.commit('app/hideSidebarMenu');
    this.getList();
    this.getWallet();

    // Select first one automatically.
    setTimeout(() => {
      this.handleClickItem(this.list[0]);
    }, 1000);
  }

  handleClickItem(card) {
    if (card.id == this.currentItem) {
      return;
    }
    this.$Loading.start();
    this.currentItem = card.id;
    this.currentVipCard = card;
    this.getOrder();
  }

  async getList() {
    await this.$store.dispatch({
      type: 'vipCard/getList',
      data: null,
    });
  }

  async getWallet() {
    await this.$store.dispatch({
      type: 'wallet/getByUser',
      data: {
        userNo: util.abp.session.getUserNoCookie()
      },
    });
  }

  async getOrder() {
    let vipCardOrder = new VipCardOrder();

    
    vipCardOrder.vipCardOrderNo = util.formatDate(new Date(), 'yyMMddHHmmss') + 'VC';

    // 第三方支付统一下单，加单号前缀
    if (this.tenant.edition === 2 && this.tenant.tenancyName.toLowerCase() !== 'funcdot') {
      vipCardOrder.vipCardOrderNo = `${appConsts.fuyouOrderNoPrefix}${vipCardOrder.vipCardOrderNo}`
    }

    vipCardOrder.userId = localStorage.getItem('fdm-user-id');
    vipCardOrder.userNo = util.abp.session.getUserNoCookie();
    vipCardOrder.userName = this.userProfile.fullName || '-';
    vipCardOrder.vipCardId = this.currentVipCard.id;
    vipCardOrder.vipCardName = this.currentVipCard.name;
    vipCardOrder.vipCardUnitPrice = this.currentVipCard.unitPrice;
    vipCardOrder.discount = this.currentVipCard.discount;
    vipCardOrder.validMonths = this.currentVipCard.validMonths;
    vipCardOrder.vipCardImageUrl = this.currentVipCard.cardImageUrl;
    vipCardOrder.coin = this.currentVipCard.coin;

    await this.$store.dispatch({
      type: 'vipCardOrder/create',
      data: vipCardOrder
    }).then(({ data }) => {
      let vipCardOrder = data.result;
      this.getQrCode('createWxPaymentQrCode', vipCardOrder);
      // this.getQrCode('createAlipayQrCode', vipCardOrder);
    });
  }

  getQrCode(paymentName, vipCardOrder: VipCardOrder) {
    let data = {
      userNo: util.abp.session.getUserNoCookie(),
      orderNo: vipCardOrder.vipCardOrderNo,
      productId: vipCardOrder.vipCardId,
      productName: vipCardOrder.vipCardName,
      productImageUrl: vipCardOrder.vipCardImageUrl,
      unitPrice: vipCardOrder.vipCardUnitPrice,
      discount: vipCardOrder.discount,
      validMonths: vipCardOrder.validMonths,
      entityName: 'VipCardOrder',
      appName: this.tenant.name,
      coin: vipCardOrder.coin
    }
    this.$store.dispatch({
      type: 'payment/' + paymentName,
      data: data
    }).then(res => {
      this.placeholderQrcodeVisible = false;
      document.getElementById(paymentName).innerHTML = '';
      new QrCode(paymentName, { width: '120', height: '120', text: res.data, colorDark: '#000', colorLight: '#fff' });
      this.$Loading.finish();
    }).catch(err => {
      this.$Loading.finish();
    });
  }
}
